import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { ChangeEvent, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { selectDefect } from "../../store/selectors/defectSelectors";
import {
  setFilters,
  setGlobalFilterValue,
  setToEdit,
} from "../../store/slices/defectSlice";
import {
  selectInspectionId,
  selectInspectionIsDisabled,
} from "../../store/selectors/inspectionSelectors";
import { createDefaultDefect } from "../../utils/defectTableHelper";
import { DefectsDeleteButton } from "./DefectsDeleteButton";
import { GenerateActionPlanButton } from "./GenerateActionPlanButton";

export const DefectTableHeader = () => {
  const dispatch = useAppDispatch();

  const { filters, globalFilterValue } = useAppSelector(selectDefect);
  const inspectionId = useAppSelector(selectInspectionId);
  const inspectionDisabled = useAppSelector(selectInspectionIsDisabled);

  const onAdd = useCallback(() => {
    if (inspectionId) {
      dispatch(setToEdit(createDefaultDefect(inspectionId)));
    }
  }, [inspectionId]);

  const onGlobalFilterChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      const updatedFilters = {
        ...filters,
        global: {
          ...filters.global,
          value: event.target.value,
        },
      };

      dispatch(setFilters(updatedFilters));
      dispatch(setGlobalFilterValue(value));
    },
    [filters]
  );

  return (
    <div className="flex justify-content-between">
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          value={globalFilterValue}
          onChange={onGlobalFilterChange}
          placeholder="Keyword Search"
        />
      </span>
      <div>
        <Button
          icon="pi pi-plus"
          className="ml-3"
          onClick={onAdd}
          disabled={inspectionDisabled}
        />
        <GenerateActionPlanButton />
        <DefectsDeleteButton />
      </div>
    </div>
  );
};
